import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { StatModule } from './stat.module';
platformBrowserDynamic().bootstrapModule(StatModule);
